var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "25",
    cy: "25",
    r: "25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.9 21.18V8.88a1.58 1.58 0 0 1 2.58-1.22l.16.15 9.9 10.72c.56.61.55 1.53 0 2.13l-.15.15-6.46 5.38 6.46 5.4c.63.52.74 1.44.28 2.1l-.13.17-9.9 10.73c-.92 1-2.55.43-2.72-.85l-.01-.22V31.2l-2.35 1.96a1.58 1.58 0 0 1-2.19-2.26l.17-.16 4.37-3.64v-1.83l-4.37-3.65a1.58 1.58 0 0 1 1.83-2.55l.19.13 2.35 1.97V8.88v12.3zm3.56 7.06l-.4.34v10.9l6.04-6.54-5.64-4.7zm15.9-11.76a1.58 1.58 0 0 1 2.23.18c2.25 2.64 3.5 5.99 3.5 9.53 0 3.55-1.26 6.91-3.52 9.55a1.57 1.57 0 1 1-2.4-2.04 11.5 11.5 0 0 0 2.77-7.51c0-2.79-.98-5.41-2.75-7.49a1.58 1.58 0 0 1 .18-2.22zm-4.18 3.8a1.58 1.58 0 0 1 2.22.19 8.8 8.8 0 0 1-.01 11.47 1.57 1.57 0 0 1-2.4-2.05A5.66 5.66 0 0 0 35 22.5a1.57 1.57 0 0 1 .18-2.22zm-12.12-7.37v10.9l.4.33 5.64-4.69-6.04-6.54z"
  })));
});